// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__Awxq5","iconStroke":"MenuItem_iconStroke__X3N5_","iconFill":"MenuItem_iconFill__rfLLm"};